<template>
  <div class="page-body" ref="pageBodyRef">
    <a-table
      :columns="columns"
      :data-source="pList"
      bordered
      :pagination="false"
      class="simple-container"
      :scroll="{ x: '100%', y: tableYHeight }"
      @resizeColumn="handleResizeColumn"
    >
      <template #headerCell="{ column }">
        <template v-if="column.dataIndex === 'worderDate'">
          <div class="date">
            <a-select
              v-model:value="sortBy"
              :dropdownMatchSelectWidth="120"
              @change="sortByChange"
              style="font-size: 12px"
            >
              <a-select-option
                :key="item.text"
                :value="item.value"
                v-for="item in sortItem"
              >
                {{ item.text }}
              </a-select-option>
            </a-select>
          </div>
        </template>
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="['air', 'train', 'boat'].includes(column.key)">
          <div
            class="simple-card iconfont icon-feiji2"
            v-for="item in record[column.key]"
            :key="item.id"
            :class="calColor(item)"
          >
            <div class="in">
              <div class="job-complete">
                {{ getStatusText(item.jobStatus) }}
              </div>
              <div class="route-id">{{ item.routeId }}</div>

              <a-tooltip :title="item.customerPoNo + '_' + item.groupNo">
                <div class="no">
                  {{ toPrefix(item.customerPoNo, '=', 1) }}_{{ item.groupNo }}
                </div>
              </a-tooltip>
            </div>
          </div>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import dayjs from 'dayjs'
  import {
    defineProps,
    ref,
    watch,
    watchEffect,
    onMounted,
    defineEmits,
  } from 'vue'
  import { throttle, toPrefix } from '@/utils'
  const emits = defineEmits()
  const props = defineProps({
    dataList: Array,
    sortName: String,
  })
  const pageBodyRef = ref(null)
  const tableYHeight = ref(500)
  const setTableScrollH = () => {
    if (!pageBodyRef.value) return
    const tableHeader = document.querySelector('.ant-table-header')
    const tHeadHeight = tableHeader ? tableHeader.clientHeight : 44

    tableYHeight.value = pageBodyRef.value.clientHeight - tHeadHeight
  }
  onMounted(() => {
    setTimeout(setTableScrollH, 2000)
    window.addEventListener('resize', throttle(setTableScrollH, 500))
  })
  const sortItem = [
    { text: 'PlanPick', value: 'planPickupDate' },
    { text: 'RSDS', value: 'rsdsReqPickupDate' },
    { text: 'ActualPick', value: 'actualPickupDate' },
  ]
  const columns = ref([
    {
      title: 'worderDate',
      dataIndex: 'worderDate',
      width: 70,
      resizable: true,

      customRender({ text }) {
        return dayjs(text).format('MM/DD')
      },
      customCell: (record) => {
        return {
          class: dayjs(record.worderDate) < dayjs() ? 'beforeToday' : '',
        }
      },
    },
    {
      title: 'AIR',
      dataIndex: 'air',
      key: 'air',
      resizable: true,
      width: 500,
    },
    {
      title: 'TRAIN',
      key: 'train',
      dataIndex: 'train',
      resizable: true,
      width: 500,
    },
    {
      title: 'BOAT',
      key: 'boat',
      dataIndex: 'boat',
      resizable: true,
      width: 500,
    },
  ])
  const handleResizeColumn = (w, col) => {
    col.width = w
  }
  const calColor = function (item) {
    let ret = ''
    if (item.shipStatus === 2) {
      ret = 'gray'
    } else {
      if (item.planPickupDate < Date.now()) {
        if (!item.eEnd) {
          ret = 'red'
        } else {
          if (item.eEnd > Date.now()) {
            ret = 'red'
          } else {
            ret = 'yellow'
          }
        }
      } else {
        if (!item.eEnd) {
          ret = 'yellow'
        } else {
          if (item.eEnd > item.planPickupDate) {
            ret = 'yellow'
          } else {
            ret = 'green'
          }
        }
      }
    }
    let iconName =
      item.shipMode === 0
        ? 'icon-feiji2'
        : item.shipMode === 1
        ? 'icon-lunchuan2'
        : 'icon-icon3'
    return ret + ' ' + iconName
  }
  const getStatusText = function (status) {
    switch (status) {
      case '2':
        return 'FG'
      case '1':
        return 'WIP'
      case '0':
        return 'Plan'
    }
  }
  const sortBy = ref(props.sortName)
  // 控制滚动条
  const tableBoxRef = ref(null)
  const xScroll = ref(0)
  const yScroll = ref(0)
  watch(tableBoxRef, (v) => {
    if (!v) return

    tableBoxRef.value.removeEventListener('scroll', tbScrollFn)
    tableBoxRef.value.addEventListener('scroll', tbScrollFn, false)
  })
  const tbScrollFn = (e) => {
    const { scrollLeft, scrollTop } = e.target
    xScroll.value = scrollLeft
    yScroll.value = scrollTop
  }

  const workOrderInit = (items, attr) => {
    const shipModeMap = { 0: 'air', 1: 'boat', 2: 'train' }
    var dateStrArr = [],
      getData = [],
      sortDate = []

    items.forEach((item) => {
      if (item[attr] == null) {
        return
      }
      var d = dayjs(item[attr]).format('YYYY/MM/DD')
      dateStrArr.push(d)
    })
    if (dateStrArr.length != 0) {
      sortDate = Array.from(new Set(dateStrArr)).sort()

      for (var i = 0; i < sortDate.length; i++) {
        getData.push({
          worderDate: sortDate[i],
          air: [],
          train: [],
          boat: [],
        })
        items.forEach((item) => {
          var str = dayjs(item[attr]).format('YYYY/MM/DD')
          if (str == sortDate[i]) {
            getData[i][shipModeMap[item.shipMode]].push(item)
          }
        })
      }
      getData.forEach((item) => {
        //按属性排序
        item.air.sort(compare(attr))
        item.train.sort(compare(attr))
        item.boat.sort(compare(attr))
      })
      return getData
    } else {
      return []
    }
  }
  const workOrderXlist = (data) => {
    //获取不同日期中最大的订单长度
    var orderSizeArr = [],
      oArr = []
    if (!(data && data.length)) return
    data.forEach((item) => {
      orderSizeArr.push(item.amountOfWorders)
    })
    var orderMax = Math.max.apply(Math, orderSizeArr)
    for (var i = 1; i < orderMax + 1; i++) {
      oArr.push(i)
    }
    return oArr
  }
  const compare = (property) => {
    return function (a, b) {
      var value1 = a[property]
      var value2 = b[property]
      if (a.batchUploadId === b.batchUploadId) {
        return value1 - value2
      }
      return a.batchUploadId - b.batchUploadId
    }
  }

  const pList = ref([])
  const oArr = ref([])

  watchEffect(() => {
    if (props.dataList.length) {
      pList.value = workOrderInit(props.dataList, sortBy.value)
      oArr.value = workOrderXlist(pList.value)
    } else {
      pList.value = []
      oArr.value = []
    }
  })
  const sortByChange = (v) => {
    emits('sortDateChange', v)
  }
</script>
<style lang="less" scoped>
  @import '../less/scheduling.less';
  @import '../less/index.less';
  .handle {
    position: absolute;
    left: 10px;
    top: 3px;
    cursor: move;
  }
  :deep(.ant-table) {
    .beforeToday {
      color: red;
    }
    th {
      padding: 2px 5px;
      background: #f5f5f5;
      border-bottom: 1px solid #c7cdd1;
    }
    td {
      padding: 5px;
      vertical-align: top;
    }
    .date {
      .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        border: none;
        background: transparent;
        padding: 0 8px 0 0;
      }
    }
  }
</style>
